import { useMutation } from '@tanstack/react-query';
import Cookies from 'js-cookie';

import { Declarant } from '@e-origin/shared';

import { AUTH_COOKIE_NAME, AUTH_EMAIL_NAME } from '@constants';
import { queryClient } from '@hooks/queryClient';
import { showErrorToast } from '@hooks/showErrorToast';
import { useUser } from './useUser';

export const useSignOut = (callback: () => void) => {
  const { data: user } = useUser();

  const id = (user?.declarant as unknown as Declarant)?._id;

  return useMutation({
    mutationFn: async () => {
      Cookies.set(AUTH_COOKIE_NAME, '');
      localStorage.removeItem(AUTH_EMAIL_NAME);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarant', id] });
      queryClient.invalidateQueries({ queryKey: ['declarant-users', id] });
      queryClient.invalidateQueries({ queryKey: ['user-profile'] });
      callback();
    },
    onError: (error) => {
      showErrorToast(error, `Sign out failed!`);
    },
  });
};
